<template>
	<div class="cart-button">
		<h4 class="cart-button__price">
			<promo-sales-timed>
				<template v-slot:originalContent>
					{{ price | formatMoney }}
				</template>
				<template>
					{{ promoDiscount(price) | formatMoney }}
					<span class="discounted-price">
						{{ price | formatMoney }}
					</span>
				</template>
			</promo-sales-timed>
		</h4>
		<promo-sales-timed>
			<template v-slot:originalContent>
				<p class="cart-button__build-time">
					{{ shippingInfo.body | stripTags }}
				</p>
			</template>
			<template slot-scope="{ phasesInfo: { currentPhase } }">
				<holiday-savings-msg
					:phase="currentPhase"
					text="starterSeries"
				/>
			</template>
		</promo-sales-timed>
		<div class="cart-button__container">
			<button
				v-if="isInStock"
				class="cart-button__button btn"
				@click="initCart"
			>
				Add To Cart
			</button>
			<button v-else class="cart-button__button cart-button__button--disabled btn" disabled>
				Sold Out
			</button>
			<promo-sales-timed>
				<template slot-scope="{ phasesInfo: { currentPhase } }">
					<alarm-reminder v-if="currentPhase == 0" bell-color="purple" />
				</template>
			</promo-sales-timed>
		</div>
		<div class="cart-button__affirm" v-if="price">
			<affirm
				v-if="!POS_MODE && countryCode != 'CA'"
				:price="price"
				color="black"
				@click="trackFinanceClick"
			/>
			<paybright
				v-if="!POS_MODE && countryCode == 'CA'"
				:price="price"
				color="black"
				@click="trackFinanceClick"
			/>
		</div>
	</div>
</template>

<script>
const SECTION_POSITION = "Top";

import { mapState, mapGetters, mapActions } from "vuex";
import Affirm from "@c/generals/affirm";
import Paybright from "@c/generals/paybright";
import { gtmMap, gtmTrigger } from "@/util/gtm";
import PromoSalesTimed from "@/components/promo-sales-timed";
import HolidaySavingsMsg from "@c/generals/holiday-saving-msg";
import { promoDiscount } from "@u/helpers";

export default {
	name: "AddToCartButton",
	components: {
		Affirm,
		Paybright,
		PromoSalesTimed,
		HolidaySavingsMsg
	},
	props: {
		shippingInfo: {
			type: Object,
			default() {
				return {};
			}
		},
		price: {
			type: [Number, String],
			default: 0
		},
		currentVariantId: {
			type: String,
			default: ""
		},
		currentVariant: {
			type: Object,
			default() {
				return {};
			}
		}
	},
	computed: {
		...mapState({
			countryCode: state => state.User.location.country_code
		}),
		...mapGetters({
			userCurrency: "userCurrency"
		}),
		gtmProduct() {
			return gtmMap.prebuildSeriesToProduct(this.currentVariant);
		},
		isInStock() {
			return this.currentVariant.is_in_stock;
		}
	},
	methods: {
		promoDiscount,
		...mapActions({
			initSeriesCart: "PrebuildSeries/initSeriesCart"
		}),
		initCart() {
			this.initSeriesCart(this.currentVariantId);
			this.trackAddToCartClick();
			this.$router.push({ name: "starter-accessories" });
		},
		trackAddToCartClick() {
			if (this.currentVariantId) {
				gtmTrigger.addToCart(
					[this.gtmProduct],
					SECTION_POSITION,
					this.userCurrency
				);
			}
		},
		trackFinanceClick() {
			if (this.currentVariantId) {
				gtmTrigger.quotedPaymentClick(this.gtmProduct, SECTION_POSITION);
			}
		}
	}
};
</script>

<style lang="scss">
.cart-button {
	.affirm-as-low-as,
	.__affirm-logo-black {
		color: #444259;
	}

	.affirm-as-low-as {
		font-weight: bold;
	}

	.__affirm-logo-black {
		font-size: 20px;
		margin-left: 5px;
	}

	.affirm-modal-trigger {
		display: block;
		font-weight: normal;
		color: #8d29a0;
	}

	.affirm.pointer:hover .affirm-modal-trigger {
		text-decoration: underline;
	}
}
</style>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.cart-button::v-deep {
	.holiday-savings-msg {
		color: #5f707f;
		font-size: 16px;
		margin-bottom: 14px;
	}

	p {
		line-height: 19px !important;
		color: #5f707f !important;
		margin-bottom: 5px !important;
	}

	.discounted-price {
		color: #5f707f;
		margin-bottom: 0;
		font-size: 14px;
		font-weight: normal;
		text-decoration: line-through;
	}
}

.cart-button {
	margin-bottom: 30px;

	&__price {
		font-size: 24px;
		color: #444259;
		margin: 0;
		font-weight: bold;

		span {
			font-size: 16px;
		}
	}

	&__build-time {
		color: #5f707f;
		font-size: 16px;
		letter-spacing: 0;
		margin-bottom: 10px;
	}

	&__button {
		width: 100%;
		background-color: $oldpurple;
		text-transform: unset;
		color: #ffffff;
		font-size: 16px;
		font-weight: bold;
		letter-spacing: 0;
		padding: 11px;
		border-radius: 2px;
		outline: 0;

		@media (min-width: 991px) {
			&:hover {
				background-color: transparent;
				color: $oldpurple;
				border: solid 2px $oldpurple;
			}
		}
	}

	&__button--disabled {
		background-color: #CFD4D8;
		pointer-events: none;
		opacity: 1;
	}

	&__affirm {
		margin-top: 10px;
	}

	&__container {
		display: flex;
	}
}
</style>
